












import { defineComponent, computed } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { useLearnMore } from '@tt4b/ttam-hooks';
import ALink from '../a-link/a-link.vue';

export default defineComponent({
  name: 'TtamLearnMore',

  components: { ALink },

  props: {
    contentType: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { helpLink } = useLearnMore(props.contentType);

    const label = computed(() => i18n.t('common_learn_more'));

    return {
      label,
      helpLink,
    };
  },
});
